export default __webpack_public_path__ + "static/media/slider_3.dcc6c5af.png";